//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetKvlist } from '@/api/kv.js';
import { whereGql } from '@/graphql/util';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customBranch: '',
      branch: '',
      remark: '',
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.name = '';
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      const branchRegex = /^(?:hotfix|feature|release|chore|bugfix)\/.+$|^master(?:\/.+)?$/;
      if (!this.customBranch || (this.tab === 'mp' && !this.branch)) {
        this.$message.error('请输入分支名');
        return;
      }
      if (!branchRegex.test(this.customBranch)) {
        this.$message.error('定制分支格式不正确');
        return;
      }
      if (this.tab === 'mp' && !branchRegex.test(this.branch)) {
        this.$message.error('标品分支格式不正确');
        return;
      }
      GetKvlist({
        limit: 1,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: `front_end_build_config`,
          },
        ]),
      })
        .then((res) => {
          const kv = res?.kv._data?.[0] || {};
          const preData = JSON.parse(kv?.value || '{}')?.[this.tab] || {};
          console.log('meow', kv, preData);
          const data = {
            customBranch: this.customBranch,
          };
          if (this.tab === 'mp') {
            data.branch = this.branch;
          }
          this.$emit('submit', data);
        })
        .catch((e) => {
          console.error(e);
          this.$message.error('获取配置失败');
        });
    },
  },
};
